import { useContext } from 'react';

import { SalesforceExportContext } from './context';

export const useSalesforceExport = () => {
  const data = useContext(SalesforceExportContext);

  return data;
};
